import type * as Types from '../../../schemas/shopify/admin.types';

export type PickPagePageNodeFragment = Pick<
  Types.Page,
  'id' | 'handle' | 'title' | 'isPublished' | 'templateSuffix'
>;

export const PickPagePageNodeFragmentDoc = `
    fragment PickPagePageNode on Page {
  id
  handle
  title
  isPublished
  templateSuffix
}
    `;
